import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const BackButton = ({ to, label = 'Volver', className = '', style = {} }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`btn btn-link p-0 text-decoration-none ${className}`}
      style={{ color: '#6c757d', fontSize: '0.9rem', ...style }}
    >
      <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
      {label}
    </button>
  );
};

export default BackButton;
